import NotFound from 'containers/pages/not-found';
import PropTypes from 'prop-types';
import React from 'react';
import { Outlet } from 'react-router-dom';

function ProtectedRoutes({
  hasSupportTicketsAccess = false,
  hasClientMeetingsAccess = false,
  hasDocuSyncAccess = false,
  hasDocuCheckAccess = false,
}) {
  const { pathname } = window.location;

  if (pathname.startsWith('/client-requests') && !hasSupportTicketsAccess) {
    return <NotFound />;
  }

  if (pathname.startsWith('/meetings') && !hasClientMeetingsAccess) {
    return <NotFound />;
  }

  if (pathname.startsWith('/docu-sync') && !hasDocuSyncAccess) {
    return <NotFound />;
  }

  if (pathname.startsWith('/docu-check') && !hasDocuCheckAccess) {
    return <NotFound />;
  }

  return <Outlet />;
}

ProtectedRoutes.propTypes = {
  hasSupportTicketsAccess: PropTypes.bool,
  hasClientMeetingsAccess: PropTypes.bool,
  hasDocuSyncAccess: PropTypes.bool,
  hasDocuCheckAccess: PropTypes.bool,
};

export default ProtectedRoutes;
